import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.auth.user$.pipe(
      map(user => {
        if (!user) {
          this.router.navigate(['/auth/login']);
          return false;
        }

        const userJson = sessionStorage.getItem('currentUser');
        if (!userJson) {
          this.auth.logout();
          return false;
        }

        try {
          const currentUser = JSON.parse(userJson);
          // Role-based access control
          if (currentUser.tipo_usuario !== 'Administrador Web') {
            if (currentUser.tipo_usuario === 'Fiscalizador' && state.url.startsWith('/fipa/usuarios')) {
              this.router.navigate(['/fipa/lotes/listado-lotes']);
              return false;
            } else if (state.url.startsWith('/fipa/usuarios') || state.url.startsWith('/fipa/ubicaciones')) {
              // Optionally, redirect to a default page for that user
              this.router.navigate(['/fipa/lotes/listado-lotes']);
              return false;
            }
          }

          return true;

        } catch (e) {
          // If JSON is invalid, the session is corrupted. Logout.
          console.error('Failed to parse user data from session storage.', e);
          this.auth.logout();
          return false;
        }
      })
    );
  }
}
